import {
  aCategory,
  anInsight,
  anInsightPage,
  anInsightStatus,
  aTeamPage,
  aUser,
  InsightFieldsFragment,
  InsightSeverityPyEnum,
  mockInsightsListQueryOperationQuery,
} from '__generated__';
import { HttpResponse } from 'msw';

export const insightsListResponse = {
  __typename: 'Query' as const,
  insights: anInsightPage(),
};

export const mockInsight: Partial<InsightFieldsFragment> = {
  __typename: 'Insight',
  id: '1',
  readableId: 'INSIGHT-123',
  name: 'Test Insight',
  created: '2023-10-21T19:57:29.748971',
  status: {
    __typename: 'InsightStatusName',
    id: 'open',
    name: 'Open',
    displayName: 'Open',
  },
  severity: InsightSeverityPyEnum.High,
  entity: {
    __typename: 'EntityInterface',
    isWhitelisted: false,
    id: 'entity-1',
    entityType: 'host',
    entityTypeName: 'Host',
    value: 'test-host',
  },
  assignee: aUser(),
  signalCount: 10,
  uniqueSignalCount: 5,
  confidence: 50,
  tags: [],
};

export const mockInsights = [
  mockInsight,
  {
    ...mockInsight,
    id: '2',
    readableId: 'INSIGHT-234',
    name: 'Test Insight 2',
  },
  {
    ...mockInsight,
    id: '3',
    readableId: 'INSIGHT-345',
    name: 'Test Insight 3',
  },
  {
    ...mockInsight,
    id: '4',
    readableId: 'INSIGHT-456',
    name: 'Test Insight 4',
  },
];

export const mockInsightsListQueryOperation = {
  __typename: 'Query',
  insights: anInsightPage({
    objects: [
      // @ts-expect-error assignee fails type checking here because it can be multiple different types
      anInsight(mockInsights[0]),
      // @ts-expect-error assignee fails type checking here because it can be multiple different types
      anInsight(mockInsights[1]),
    ],
  }),
  insightStatuses: [anInsightStatus()],
  teams: aTeamPage(),
  categories: [aCategory()],
};

export const mockInsightsListQueryOperation_federated = {
  __typename: 'Query',
  insights: anInsightPage({
    objects: [
      // @ts-expect-error assignee fails type checking here because it can be multiple different types
      anInsight({
        ...mockInsights[0],
        tenant: 'federated-tenant-1',
        tenantUrl: 'https://federated-tenant-1.sumologic.com/sec',
        tenantName: 'Federated Tenant 1',
        deployment: 'stag',
      }),
      // @ts-expect-error assignee fails type checking here because it can be multiple different types
      anInsight({
        ...mockInsights[1],
        tenant: 'federated-tenant-2',
        tenantUrl: 'https://federated-tenant-2.sumologic.com/sec',
        tenantName: 'Federated Tenant 2',
        deployment: 'stag',
      }),
    ],
  }),
  insightStatuses: [anInsightStatus()],
  teams: aTeamPage(),
  categories: [aCategory()],
};

export const handlers = [
  mockInsightsListQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insights: anInsightPage({
            objects: [
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[0],
              }),
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[1],
              }),
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[2],
              }),
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[3],
              }),
            ],
          }),
          insightStatuses: [anInsightStatus()],
          teams: aTeamPage(),
          categories: [aCategory()],
        },
      });
    }
  ),
];
